var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "750" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("visibility")]),
                  _vm._v("SEGUIMIENTO PLANILLA DETALLE\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "px-2" },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "text-xs-center blue--text",
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(this.form.ap_paterno) +
                              " " +
                              _vm._s(this.form.ap_materno) +
                              "\n              " +
                              _vm._s(this.form.nombres)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { shrink: "" } }, [
                        _c("b", [_vm._v(" GESTIÓN:")]),
                        _vm._v(" " + _vm._s(this.form.gestion) + " ")
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { shrink: "" } }, [
                        _c("b", [_vm._v(" MES:")]),
                        _vm._v(" " + _vm._s(this.form.mes) + " ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.l_seguimiento,
                              "no-data-text": _vm.loading
                                ? "Cargando..."
                                : "No se tiene registros",
                              loading: _vm.loading,
                              "item-key": "index",
                              "rows-per-page-text": "Filas por pagina",
                              pagination: _vm.pagination
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "headers",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "tr",
                                      _vm._l(props.headers, function(header) {
                                        return _c(
                                          "th",
                                          {
                                            key: header.text,
                                            class: [
                                              "column sortable",
                                              _vm.pagination.descending
                                                ? "desc"
                                                : "asc",
                                              header.value ===
                                              _vm.pagination.sortBy
                                                ? "active"
                                                : ""
                                            ],
                                            attrs: { id: "cabecera_tabla" },
                                            on: {
                                              click: function($event) {
                                                return _vm.changeSort(
                                                  header.value
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "white"
                                                }
                                              },
                                              [_vm._v("arrow_upward")]
                                            ),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(header.text) +
                                                "\n                  "
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                }
                              },
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm
                                                .$moment(props.item._created_at)
                                                .format("DD/MM/YYYY")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm
                                                .$moment(props.item._created_at)
                                                .format("HH:mm")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              props.item.usuario.nombre_usuario
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              props.item.cerrado
                                                ? "CERRADO"
                                                : "ABIERTO"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.motivo) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-751d31a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751d31a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/dialogs/VerSeguimientoPlanilla.vue
// module id = null
// module chunks = 